if (!customElements.get('sticky-atc-btn')) {
  class StickyAtcBtn extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

       //this.cardMedia = this.productSection.querySelector('sticky-atc-btn  .card__media');
      // this.cardInfo = this.productSection.querySelector('sticky-atc-btn  .card__info');
     

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcBtn.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-btn--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-btn--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcBtn.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      /*
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    */
      const isSmallScreen = window.innerWidth < 769; // 常见移动设备断点
      if (isSmallScreen) {
       // return "mobile";
        //this.cardMedia.style.display = 'none';
       // this.cardInfo.style.display = 'none';
        
      } else {
       // return "desktop";
       //this.cardMedia.style.display = 'block';
        //this.cardInfo.style.display = 'block';
      }
    }
  }

  customElements.define('sticky-atc-btn', StickyAtcBtn);
}
